import { useQuery } from "@tanstack/react-query"
import apiRoutes from "../apiRoutes"
import api from "../utils"

export const CheckEnablers = (type: string) => {
    const getEnablers = async () => {
        const res = await api.post(apiRoutes.checkEnablers, {
            type
        })
        return res.data
    }

    const { data, ...rest } = useQuery({
        queryKey: [`check_enablers_${type}`],
        queryFn: getEnablers
    })

    return {
        data,
        ...rest
    }
}